import { useTranslation } from 'react-i18next';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { Button } from '~/components/ui/button';

export function AppError({ error }: ErrorComponentProps) {
  const { t } = useTranslation();
  const errorDetails = error instanceof Error ? error.stack : String(error);

  return (
    <div className="flex min-h-56 flex-col items-center justify-center gap-4 bg-background p-8 text-center">
      <div className="space-y-1">
        <h1 className="text-lg font-semibold text-foreground">
          {t('Unable to load this page.')}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t('Reload the page and try again.')}
        </p>
      </div>
      <Button
        type="button"
        variant="outline"
        onClick={() => window.location.reload()}
      >
        {t('Reload')}
      </Button>
      {import.meta.env.DEV && (
        <pre className="max-w-full overflow-auto text-left text-xs text-muted-foreground">
          {errorDetails}
        </pre>
      )}
    </div>
  );
}
